__turbopack_context__.v({
  "banner": "Sertificate-module-scss-module__R2-U3W__banner",
  "bannerImage": "Sertificate-module-scss-module__R2-U3W__bannerImage",
  "content": "Sertificate-module-scss-module__R2-U3W__content",
  "contentList": "Sertificate-module-scss-module__R2-U3W__contentList",
  "contentTitle": "Sertificate-module-scss-module__R2-U3W__contentTitle",
  "contentTop": "Sertificate-module-scss-module__R2-U3W__contentTop",
  "contentValue": "Sertificate-module-scss-module__R2-U3W__contentValue",
  "root": "Sertificate-module-scss-module__R2-U3W__root",
  "title": "Sertificate-module-scss-module__R2-U3W__title",
});
